import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.72 13.845q-.36.045-.72.096m.72-.096a42.4 42.4 0 0 1 10.56 0m-10.56 0-.38 4.171m10.94-4.171q.36.045.72.096m-.72-.096.38 4.171m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227l.229-2.523m11.318 0h1.091a2.25 2.25 0 0 0 2.25-2.25V9.472c0-1.081-.768-2.015-1.837-2.175a48 48 0 0 0-1.913-.247M6.34 18.016H5.25A2.25 2.25 0 0 1 3 15.766V9.472c0-1.081.768-2.015 1.837-2.175A48 48 0 0 1 6.75 7.05m10.5 0a48.5 48.5 0 0 0-10.5 0m10.5 0V3.39c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.66M18 10.516h.008v.008H18zm-3 0h.008v.008H15z"
    }, null, -1)
  ])))
}
export default { render: render }